module.exports = __webpack_public_path__ + "static/media/teletava7.df6df42d.png";